import React, { useEffect, useState } from "react";
import { Card, Select, Row, Col, message, Typography, Divider } from "antd";
import dataService from "../networks/api/service/dataService";
import ElectionFileUpload from "../components/ElectionFileUpload";

const { Option } = Select;
const { Title } = Typography;

function ElectionDetailsUpload() {
  const [parliamentId, setparliamentId] = useState(null);
  const [assemblyId, setAssemblyId] = useState(null);
  const [panchayatId, setPanchayatId] = useState(null);
  const [year, setYear] = useState(null);
  const [election, setelection] = useState(null);

  const [parliamentList, setparliamentList] = useState([]);
  const [assemblyList, setAssemblyList] = useState([]);
  const [panchayatList, setPanchayatList] = useState([]);
  const [resetTableFlag, setResetTableFlag] = useState(false);

  useEffect(() => {
    getparliament();
  }, []);

  useEffect(() => {}, []);

  const getExcelData = async (formData) => {
    const details = {
      election: election,
      assembly: assemblyId,
      panchayat: panchayatId,
      year: year,
      electionDetails: formData,
    };
    console.log(details, "fsormData");
    try {
      let response;
      if (election === "AC") {
        response = await dataService.uploadAcDetails(details);
      } else if (election === "PC") {
        response = await dataService.uploadPcDetails(details);
      }
      if (response.code === 200) {
        setparliamentId(null);
        setAssemblyId(null);
        setPanchayatId(null);
        setYear(null);
        setelection(null);
        setResetTableFlag((prev) => !prev);
        message.success(response.message);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getparliament = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) {
        setparliamentList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const OnparliamentSelect = async (value) => {
    setparliamentId(value);
    setAssemblyId("");
    setPanchayatId("");
    setAssemblyList([]);
    setPanchayatList([]);
    setYear(null);
    setelection(null);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) {
        setAssemblyList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const OnAssemblySelect = async (value) => {
    setAssemblyId(value);
    setPanchayatId("");
    setPanchayatList([]);
    setYear(null);
    setelection(null);
    const data = { assembly: value };
    try {
      const res = await dataService.getPanchayatFromAssembly(data);
      if (res.code === 200) {
        setPanchayatList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const OnPanchayatSelect = (value) => {
    setPanchayatId(value);
    setYear(null);
    setelection(null);
  };

  const OnYearSelect = (value) => {
    setYear(value);
  };

  const OnElectionSelect = (value) => {
    setelection(value);
  };

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Title level={4} style={{ textAlign: "center", marginBottom: "20px" }}>
          Election Details Upload
        </Title>
        <Divider />
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={12} md={8}>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Parliament"
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 5,
              }}
              onChange={OnparliamentSelect}
              value={parliamentId}
            >
              <Option key={827272} value="" disabled>
                Select Parliament
              </Option>
              {parliamentList?.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.constituencyName}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Assembly"
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 5,
              }}
              onChange={OnAssemblySelect}
              value={assemblyId}
            >
              <Option key={827272} value="" disabled>
                Select Assembly
              </Option>
              {assemblyList?.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.assemblyName}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Panchayat"
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 5,
              }}
              onChange={OnPanchayatSelect}
              value={panchayatId}
            >
              <Option key={827272} value="" disabled>
                Select Panchayat
              </Option>
              {panchayatList?.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.panchayatName}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row gutter={[16, 16]} justify="center" style={{ marginTop: "16px" }}>
          <Col xs={24} sm={12} md={8}>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Year"
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 5,
              }}
              onChange={OnYearSelect}
              value={year}
            >
              <Option key={827272} value="" disabled>
                Select Year
              </Option>

              {[2024, 2019, 2014].map((y) => (
                <Option key={y} value={y}>
                  {y}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Election Type"
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 5,
              }}
              onChange={OnElectionSelect}
              value={election}
            >
              <Option key={827272} value="" disabled>
                Select Election
              </Option>

              <Option key="AC" value="AC">
                AC
              </Option>
              <Option key="PC" value="PC">
                PC
              </Option>
            </Select>
          </Col>
        </Row>
        <Divider style={{ marginTop: "20px" }} />
        <ElectionFileUpload
          getExcelData={getExcelData}
          resetTable={resetTableFlag}
        />
      </Card>
    </div>
  );
}

export default ElectionDetailsUpload;
